import { createAsyncThunk } from '@reduxjs/toolkit';
import { fbStore } from '../../utils/firebase';

export const findCategory = async () => {
  try {
    return fbStore
      .collection('categories')
      .orderBy('createdAt', 'desc')
      .get()
      .then((querySnapshot) => querySnapshot.docs.map((item) => ({ ...item.data(), id: item.id })));
  } catch (err) {
    return [];
  }
};

export const getCategories = createAsyncThunk('category/list', async (_, { rejectWithValue }) => {
  try {
    const categories = await fbStore
      .collection('categories')
      .orderBy('createdAt', 'desc')
      .get()
      .then((querySnapshot) => querySnapshot.docs.map((item) => ({ ...item.data(), id: item.id })));
    return categories;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const addCategory = createAsyncThunk(
  'category/create',
  async (data, { rejectWithValue }) => {
    try {
      const phrase = await fbStore.collection('categories').add({
        ...data,
        createdAt: new Date().toISOString(),
      });
      const res = await phrase.get();
      return {
        id: phrase.id,
        ...res.data(),
      };
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const updateCategory = createAsyncThunk(
  'category/update',
  async (data, { rejectWithValue }) => {
    try {
      await fbStore.collection('categories').doc(data.id).set(data, { merge: true });
      return data.id;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const removeCategory = createAsyncThunk(
  'category/remove',
  async (categoryId, { rejectWithValue }) => {
    try {
      await fbStore.collection('categories').doc(categoryId).delete();
      return categoryId;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
